(() => {
  function init(root) {
    if (root.dataset.contactReady) return;
    root.dataset.contactReady = 'true';
    const form = root.querySelector('form'), type = root.querySelector('[data-contact-type]');
    if (!form || !type) return;
    const general = root.querySelector('[data-contact-general]'), order = root.querySelector('[data-contact-order]');
    const title = root.querySelector('[data-contact-title]'), id = root.querySelector('[data-contact-order-id]');
    const action = root.querySelector('[data-contact-action]'), message = root.querySelector('[data-contact-message]');
    const label = root.querySelector('[data-contact-message-label]'), summary = root.querySelector('[data-contact-summary]');
    function update() {
      const existing = type.value === 'Existing order';
      general.hidden = existing;
      order.hidden = !existing;
      title.disabled = existing;
      title.required = !existing;
      id.disabled = action.disabled = !existing;
      id.required = action.required = existing;
      message.required = !existing || action.value !== 'Full refund';
      label.textContent = message.required ? label.dataset.labelRequired : label.dataset.labelOptional;
      summary.value = '(Form) ' + (existing ? (action.value || 'Existing order') + (id.value.trim() ? ' - ' + id.value.trim() : '') : title.value.trim() || 'General request');
    }
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', update);
    update();
  }
  document.querySelectorAll('[data-contact-section]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-contact-section]').forEach(init));
})();
